<template>
  <div class="meituanHome">
    <van-form class="container" @submit="onSubmit" validate-first>
      <van-field
        v-model="form.mobile"
        type="number"
        clearable
        center
        :left-icon="require('@/assets/img/meituan/phone.png')"
        placeholder="手机号码"
        :rules="[
          { required: true, message: '请填写手机号码' },
          { pattern: /^1[3456789]\d{9}$/, message: '请填写正确的手机号码' }
        ]"
      />
      <van-field
        v-model="form.verifyCode"
        center
        clearable
        :left-icon="require('@/assets/img/meituan/icon_pad.png')"
        placeholder="短信验证码"
        :rules="[{ required: true, message: '请填写短信验证码' }]"
      >
        <template #button>
          <van-button
            size="small"
            color="#FAC530"
            v-if="!timer"
            loading-text="发送中..."
            :loading="yzmLoading"
            @click.stop="getCodeMeds"
            native-type="button"
          >
            发送验证码
          </van-button>
          <van-count-down v-else :time="timer" @finish="timer = 0" />
        </template>
      </van-field>
      <van-button
        block
        color="#FAC530"
        loading-text="加载中..."
        :loading="loading"
        class="redeemBtn"
        native-type="submit"
      >
        登录
      </van-button>
    </van-form>
  </div>
</template>

<script>
import { sendVerifyCodeForH5, loginForH5 } from '@/api/mtH5'
export default {
  name: 'mtH5Login',
  data() {
    return {
      form: {
        mobile: '',
        verifyCode: ''
      },
      loading: false,
      yzmLoading: false,
      timer: 0
    }
  },
  created() {},
  methods: {
    async getCodeMeds() {
      const reg = /^1[3456789]\d{9}$/
      if (!this.form.mobile && !reg.test(this.form.mobile)) {
        this.$toast.fail('请填写正确的手机号')
        return
      }
      this.yzmLoading = true
      const { code } = await sendVerifyCodeForH5({
        bizType: 1, // 业务类型，1-登录，2-验券
        mobile: this.form.mobile
      }).finally(() => {
        this.yzmLoading = false
      })
      if (code === 0) {
        this.timer = 60000
      }
    },
    async onSubmit() {
      try {
        this.loading = true
        const { code, data } = await loginForH5(this.form)
        if (code === 0) {
          sessionStorage.setItem('mtH5Token', data?.token)
          this.$router.push({
            name: 'mtH5List',
            query: { mobile: this.form.mobile }
          })
        }
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.meituanHome {
  min-height: 100vh;
  background: #ffea8e url(../../assets/img/meituan/indexBg.jpg) top center
    no-repeat;
  background-size: 100% auto;
  .container {
    position: fixed;
    bottom: 8%;
    width: 90%;
    left: 5%;
    padding: 49px 23px 75px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 15px;
    .formInput {
      background: #f5f7fd;
      border-radius: 10px;
      &::after {
        border-bottom: none;
      }
    }
    .redeemBtn {
      color: #000;
      margin: 30px 0 21px;
      border-radius: 10px;
      font-size: 16px;
      color: #000000;
    }
  }
}
</style>
